import { render } from "./NotificationBar.vue?vue&type=template&id=13176d59&ts=true"
import script from "./NotificationBar.vue?vue&type=script&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&lang=ts"

import "./NotificationBar.vue?vue&type=style&index=0&id=13176d59&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__